<script setup lang="ts">
import type { MenuItemProps } from "./types";
import { CheckIcon, ChevronRightIcon } from "lucide-vue-next";

const props = withDefaults(defineProps<MenuItemProps>(), {
  checkboxPosition: "before",
});
</script>

<template>
  <component
    :is="as || 'div'"
    class="inline-grid items-center rounded-sm p-1 whitespace-nowrap text-inherit outline-hidden select-none data-disabled:text-slate-500 data-highlighted:bg-gray-200/40"
    :class="{
      '[[data-state=open]&:not([data-highlighted])]:bg-slate-200': subTrigger,
      'col-span-full grid grid-cols-subgrid': !customGrid,
    }"
  >
    <CheckIcon v-if="props.checked && props.checkboxPosition === 'before'" class="col-start-1 mr-2 size-4" aria-hidden="true" />
    <component :is="props.icon" v-if="props.icon" class="col-start-2 mr-2 flex size-4 items-center" aria-hidden="true" />
    <div v-else-if="$slots.icon" class="relative top-0.5 col-start-2 mr-2 flex self-start">
      <slot name="icon" />
    </div>
    <div class="col-start-3 min-w-0 text-left">
      <slot />
    </div>
    <div v-if="props.shortcut" class="ml-2 flex justify-self-end text-neutral-400">
      {{ typeof props.shortcut === 'string' ? props.shortcut : props.shortcut.label }}
    </div>
    <div v-else-if="$slots.shortcut" class="ml-2 flex justify-self-end text-neutral-400">
      <slot name="shortcut" />
    </div>
    <CheckIcon v-if="props.checked && props.checkboxPosition === 'after'" class="col-start-4 mr-2 size-4" aria-hidden="true" />
    <slot name="sub" />
    <ChevronRightIcon v-if="subTrigger" class="ml-2 flex size-4 justify-self-end" />
    <component :is="props.suffixIcon" v-if="props.suffixIcon" class="ml-2 size-4 justify-self-end" aria-hidden="true" />
  </component>
</template>
